/**
 * Button adapter.
 *
 * The library's Button already covers this app's needs — variants
 * "primary" | "secondary" | "ghost" | "outline" | "danger", sizes
 * "sm" | "md" | "lg", plus `loading`, `startIcon`, `endIcon`. This wrapper
 * exists as the seam for app-specific additions, and currently adds one:
 *
 *   variant="secondary-solid" — teal label, teal icon and teal edge on a black
 *   fill. Use it for the cancel-style button beside a primary: the teal matches
 *   the primary's fill so the pair reads as one set, and the solid fill means
 *   it still reads as a button when it sits ON a raised surface such as the
 *   Note action bar, where a transparent secondary would just take the bar's
 *   colour.
 *
 * It is implemented by overriding the library's own `--_bg` / `--_fg` / `--_bd`
 * custom properties rather than restyling `.amd-btn`, so hover lift, active
 * state and focus ring all remain the library's.
 */
import { Button as LibraryButton } from '@amd-deae-ceme/design-system';

import { cx } from '@lib/classNames';

import styles from './Button.module.css';

/** App-only variants → the library variant they build on, plus our class. */
const APP_VARIANTS = {
  'secondary-solid': { base: 'secondary', className: styles.secondarySolid },
};

export function Button({ variant = 'secondary', className, ...rest }) {
  const app = APP_VARIANTS[variant];

  return (
    <LibraryButton
      variant={app ? app.base : variant}
      className={cx(app?.className, className)}
      {...rest}
    />
  );
}

export default Button;
